import { signalStoreFeature } from '@ngrx/signals';
import { withEventHandlers } from '@ngrx/signals/events';

export function withBunkerEffects() {
  return signalStoreFeature(
    withEventHandlers(() => {
      return {};
    })
  );
}
